import React from "react";

const Backdrop = (props) => {
  return <div onClick={props.clicked} className="fixed h-screen w-screen z-40 bg-gray-500/75"></div>;
};

export default Backdrop;
